import React from "react";
import { Link } from "react-router-dom";
import { imagePath } from "../../utils/assetUtils";
import MenuItem from "./menuitem";
import { FaPhoneAlt } from "react-icons/fa";
import "./navigation.scss";

export default function Navigation() {
  return (
    <header id="get-started" className="main-head-wrap">
      <div className="menu-wrapper">
        <div className="logo-wrapper">
          <Link to="/" id="header-logo">
            <img src={imagePath("logo.png")} alt="logo" />
          </Link>
        </div>

        <div className="phone-wrap-menu">
          <a
            id="mobile-header-phone"
            className="phone-icon-menu phone-ring-icon"
            href="tel:+91 9136651479"
          >
            <FaPhoneAlt fill="#fff" />
          </a>
        </div>

        <MenuItem />
      </div>
    </header>
  );
}
